import type { CSSProperties } from "react";
import type { MoversDTO } from "../../shared/types";
import { formatPct, returnColor } from "../lib/format";

/**
 * CNBC-style scrolling crawl of every open position's live return. Fed by
 * /api/movers (already polled on the Season page). Doubled content + a -50%
 * translate gives a seamless loop; speed scales with item count so it reads at
 * a steady pace regardless of how many positions are held.
 */
export function TickerTape({ data }: { data: MoversDTO | null }) {
  const items = data?.positions ?? [];
  if (items.length === 0) return null;
  const row = [...items, ...items];
  const dur = Math.max(24, Math.round(items.length * 2.4));
  return (
    <div className="panel-tight overflow-hidden py-2" aria-label="Live position returns">
      <div
        className="ticker-track flex w-max items-center"
        style={{ "--scb-dur": `${dur}s` } as CSSProperties}
      >
        {row.map((p, i) => (
          <span
            key={i}
            className="num mr-7 flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold"
          >
            <span className="text-fg">{p.ticker}</span>
            <span className={returnColor(p.return)}>
              {p.return > 0 ? "▲" : p.return < 0 ? "▼" : "•"} {formatPct(p.return)}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}
